/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalCost } from '../models/AdditionalCost';
import type { AdditionalCostRequest } from '../models/AdditionalCostRequest';
import type { Pageable } from '../models/Pageable';
import type { PageAdditionalCost } from '../models/PageAdditionalCost';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdditionalCostRestEndpointService {
    /**
     * @returns AdditionalCost OK
     * @throws ApiError
     */
    public static dashboardUpdateAdditionalCost({
        costId,
        requestBody,
    }: {
        costId: number,
        requestBody: AdditionalCostRequest,
    }): CancelablePromise<AdditionalCost> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/accounting/additional-costs/{costId}',
            path: {
                'costId': costId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static dashboardDeleteAdditionalCost({
        costId,
    }: {
        costId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/accounting/additional-costs/{costId}',
            path: {
                'costId': costId,
            },
        });
    }
    /**
     * @returns PageAdditionalCost OK
     * @throws ApiError
     */
    public static dashboardGetAdditionalCosts({
        from,
        to,
        pageable,
    }: {
        from: string,
        to: string,
        pageable: Pageable,
    }): CancelablePromise<PageAdditionalCost> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/accounting/additional-costs',
            query: {
                'from': from,
                'to': to,
                'pageable': pageable,
            },
        });
    }
    /**
     * @returns AdditionalCost OK
     * @throws ApiError
     */
    public static dashboardCreateAdditionalCost({
        requestBody,
    }: {
        requestBody: AdditionalCostRequest,
    }): CancelablePromise<AdditionalCost> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/accounting/additional-costs',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
